import useSendPageVisitEvents from '../../hooks/useSendPageVisitEvents';
import useTrackPageViews from '../../hooks/useTrackPageViews';
import useUpdatePageTitles from '../../hooks/useUpdatePageTitles';
import useOnboardingNavigation from '../../hooks/useOnboardingNavigation';
import useAutoActivateTrial from '../../hooks/useAutoActivateTrial';
import useTestsHelper from '../../hooks/useTestsHelper';
import useWebSockets from '../../webSockets/useWebSockets';
import { useSweepRoleGroups } from '../common/useSweepRoleGroups';
import { useSelectDefaultCreationEnvHeuristic } from './environments/useSelectDefaultCreationEnvHeuristic';
import { useAuthenticatedAppHubspotLoad } from './canvas-pages/canvas-hubspot-page/useAuthenticatedAppHubspotLoad';
import useSetupMonitoring from '../../hooks/useSetupMonitoring';
import LoadingSweep from '../common/LoadingSweep';
import useSendMeetingBookedEvents from '../../hooks/useSendMeetingBookedEvents';
import HomeInitialized from './HomeInitialized';
import { useRedirectLegacyQueryParams } from '../../navigation-utils/useRedirectLegacyQueryParams';
import { useInitializeLdEffect } from '../../feature-flags/useInitializeLD';
import useProcessMiningCleanup from '../../hooks/useProcessMiningCleanup';
import useLoadAccount from '../../hooks/useLoadAccount';
import { WithAccountsSelectionDialog } from '../account-selection/WithAccountsSelectionDialog';
import { useFeatureToggle } from '../../feature-flags/useFeatureToggle';
import { useRemoveAuthOrgQueryParamFromUrl } from '../../hooks/useRemoveAuthOrgQueryParamFromUrl';
import { useAccountSelectionContext } from '../account-selection/AccountSelectionContext';

const Home = () => {
  //Here goes initializations that DON'T require "crmOrgs" or "hubspot" to be initialized:
  useRedirectLegacyQueryParams();
  useSendPageVisitEvents();
  useTrackPageViews();
  useUpdatePageTitles();
  useAutoActivateTrial();
  useOnboardingNavigation();
  useSendMeetingBookedEvents();
  useTestsHelper();
  useWebSockets();
  useProcessMiningCleanup();
  useSweepRoleGroups();
  useLoadAccount();
  useRemoveAuthOrgQueryParamFromUrl();

  const { crmOrgsAreReady } = useSelectDefaultCreationEnvHeuristic();
  const { hubspotInitialized } = useAuthenticatedAppHubspotLoad();
  useSetupMonitoring();
  const { ldReady } = useInitializeLdEffect();
  const { multiAccounts } = useFeatureToggle();
  const { isAccountReady } = useAccountSelectionContext();

  if (!crmOrgsAreReady || !hubspotInitialized || !ldReady || !isAccountReady) {
    return <LoadingSweep />;
  }

  if (!multiAccounts) {
    return <HomeInitialized />;
  }

  return (
    <WithAccountsSelectionDialog>
      <HomeInitialized />
    </WithAccountsSelectionDialog>
  );
};

export default Home;
